<template>
  <div class="form-group">
    <label
      :for="inputId"
      class="mb-1"
    >
      {{ label }}
      <span
        v-if="sublabel"
        class="fw-normal"
      >
        {{ sublabel }}
      </span>
    </label>
    <div
      v-if="description"
      class="d-flex text-gray-700 fs-14 mb-2"
    >
      {{ description }}
    </div>
    <div class="input-group">
      <textarea
        :id="inputId"
        v-directive="{
          getValue: this.customValue,
          setValue: this.setCustomModel,
          update: updateObject,
          mask,
        }"
        rows="3"
        class="form-control bg-white"
        :class="validationClass"
        :disabled="inputDisabled"
        :readonly="readonly"
        :placeholder="placeholder"
        @focus="(event) => $emit('focus', event)"
        @blur="(event) => $emit('blur', event)"
      />
    </div>
  </div>
</template>
<script>
import directive from '@/directives/mask2';
import input from '@/mixins/input-2';

export default {
  name: 'CommonInput',
  directives: {
    directive,
  },
  mixins: [input],
  props: {
    errorMessage: {
      type: String,
      default: null,
    },
    mask: {
      type: String,
      default: 'all',
    },
    description: {
      type: [String, null],
      default: null,
    },
    readonly: {
      type: [Boolean, null],
      default: false,
    },
    sublabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      updateObject: {
        allow: true,
        forceUpdate: () => {},
      },
    };
  },
  watch: {
    storeValue: {
      handler(value) {
        if (value !== this.customValue) {
          this.updateObject.forceUpdate(value);
        }
      },
    },
  },
};
</script>
